import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";

export const useDeleteStaffRole = () => {
  const { sport, organizationId, entityId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<boolean, Error, string>({
    // The roles endpoint does not confirm the deletion in its body, so a resolved request means success
    mutationFn: async (roleId: string) => {
      await request(`${sport}/o/${organizationId}/roles/${roleId}`, { method: "DELETE" });
      return true;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["roles", sport, organizationId, entityId],
      });
      await queryClient.invalidateQueries({
        queryKey: ["roles", sport, organizationId],
      });
    },
  });
};
